// @flow
export function makeLanseURL(rcid: string): string {
  return "https://podcasts.indemandradio.com/" + rcid + "/" + rcid + ".m3u8";
}
